<template>
    <el-dialog title="关联单元主体" :close-on-click-modal="false" :visible.sync="dialogVisible" width="120rem">
        <div class="top-banner">
            <div>教学单元：</div>
            <div>{{ currentRaw.name || '暂无' }}</div>
            <div>{{ currentRaw.mainType }}</div>
        </div>
        <div class="radio-box">
            <div>所属分类：</div>
            <el-radio-group v-model="classifyCode" @input="changeCategory">
                <el-radio v-for="(item, index) in Category" :key="index" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
        </div>
        <div class="table-box">
            <el-tabs v-model="currentTab" @tab-click="handleClick">
                <el-tab-pane :label="`个人资源库（${resNum[2]}）`" name="myself">
                    <div class="box" v-if="tableData.length > 0">
                        <div v-for="(item, index) in tableData" class="table-item" @click="selectItem(item)"
                            :key="index">
                            <div class="cover-img">
                                <img :class="{ 'active-img': item.id == currentRaw.resourceId }" class="res-img"
                                    :src="item.coverPath ? $severUrl(item.coverPath) : $filterResDefault(item.type)" alt="">
                            </div>
                            <div class="cover-name overflow" :class="{ active: item.id == currentRaw.resourceId }">{{
                                item.resourceName }}</div>
                        </div>
                    </div>
                    <div class="page-box" v-if="tableData.length > 0">
                            <el-pagination background :current-page="pages.current" :page-size="pages.size"
                                layout="prev, pager, next" @current-change="changeCurrent" :total="pages.total">
                            </el-pagination>
                        </div>
                    <no-data v-else></no-data>
                </el-tab-pane>
                <el-tab-pane :label="`院校资源库（${resNum['1']}）`" name="college">
                    <div class="box" v-if="tableData.length > 0">
                        <div v-for="(item, index) in tableData" class="table-item" @click="selectItem(item)"
                            :key="index">
                            <div class="cover-img">
                                <img :class="{ 'active-img': item.id == currentRaw.resourceId }" class="res-img"
                                    :src="item.coverPath ? $severUrl(item.coverPath) : $filterResDefault(item.type)" alt="">
                            </div>
                            <div class="cover-name overflow" :class="{ active: item.id == currentRaw.resourceId }">{{
                                item.resourceName }}</div>
                        </div>
                    </div>
                    <div class="page-box" v-if="tableData.length > 0">
                            <el-pagination background :current-page="pages.current" :page-size="pages.size"
                                layout="prev, pager, next" @current-change="changeCurrent" :total="pages.total">
                            </el-pagination>
                        </div>
                    <no-data v-else></no-data>
                </el-tab-pane>
                <el-tab-pane :label="`平台资源库（${resNum['0']}）`" name="cloud">
                    <div class="box" v-if="tableData.length > 0">
                        <div v-for="(item, index) in tableData" class="table-item" @click="selectItem(item)"
                            :key="index">
                            <div class="cover-img">
                                <img :class="{ 'active-img': item.id == currentRaw.resourceId }" class="res-img"
                                    :src="item.coverPath ? $severUrl(item.coverPath) : $filterResDefault(item.type)" alt="">
                            </div>
                            <div class="cover-name overflow" :class="{ active: item.id == currentRaw.resourceId }">{{
                                item.resourceName }}</div>
                        </div>
                    </div>
                    <div class="page-box" v-if="tableData.length > 0">
                            <el-pagination background :page-size="pages.size" :current-page="pages.current"
                                layout="prev, pager, next" @current-change="changeCurrent" :total="pages.total">
                            </el-pagination>
                        </div>
                    <no-data v-else></no-data>
                </el-tab-pane>
                <el-tab-pane label="本地添加" name="local">
                    <div class="upload-box">
                        <div class="resource-name">
                            <div>资源名称</div>
                            <el-input style="width: 20rem;" v-model="resourceName" placeholder="请输入资源名称"></el-input>
                        </div>
                        <div class="resource-name">
                            <div>资源简介</div>
                            <el-input type="textarea" style="width: 20rem;" v-model="info"
                                placeholder="请输入资源简介"></el-input>
                        </div>
                        <div class="cover-box">
                            <div>资源封面</div>
                            <el-upload style="width: 5rem !important; height: 5rem !important" action="#"
                                accept=".jpg,.jpeg,.png" list-type="picture-card" :auto-upload="false"
                                :show-file-list="false" class="upload-box-img" :on-change="uploadCover">
                                <img v-if="cover.coverPath" :src="$severUrl(cover.coverPath)"
                                    style="width: 4.8rem; height: 4.8rem" />
                                <i v-else class="el-icon-plus"></i>
                            </el-upload>
                        </div>
                        <div v-if="currentRaw.mainType == '仿真软件'">
                            <div class="resource-name">
                                <div>资源类型</div>
                                <el-radio-group v-model="form.resType">
                                <el-radio label="网页">网页</el-radio>
                                </el-radio-group>
                            </div>
                            <div class="resource-name">
                                <div>资源链接</div>
                                <el-input style="width: 20rem;" v-model="url" placeholder="请输入资源链接"></el-input>
                            </div>
                            <div class="resource-name">
                                <div>实训目标</div>
                                <el-input style="width: 100%;" type="textarea" v-model="form.drillTarget"
                                    placeholder="请输入实训目标"></el-input>
                            </div>
                            <div class="resource-name">
                                <div>实训原理</div>
                                <el-input style="width: 100%;" type="textarea" v-model="form.drillTheory"
                                    placeholder="请输入实训原理"></el-input>
                            </div>
                            <div class="resource-name">
                                <div>实训步骤</div>
                                <el-input style="width: 100%;" type="textarea" v-model="form.drillStep"
                                    placeholder="请输入实训步骤"></el-input>
                            </div>
                            <div class="resource-name">
                                <div>实训方法与过程</div>
                                <el-input style="width: 100%;" type="textarea" v-model="form.drillMethodCourse"
                                    placeholder="请输入实训方法与过程"></el-input>
                            </div>
                            <div class="resource-name">
                                <div>实训结论</div>
                                <el-input style="width: 100%;" type="textarea" v-model="form.drillConclusion"
                                    placeholder="请输入实训结论"></el-input>
                            </div>
                            <div class="resource-name">
                                <div>硬件要求</div>
                                <el-input style="width: 100%;" type="textarea" v-model="form.hardwareAsk"
                                    placeholder="请输入硬件要求"></el-input>
                            </div>
                            <div class="resource-name">
                                <div>操作系统</div>
                                <el-input style="width: 100%;" type="textarea" v-model="form.os"
                                    placeholder="请输入操作系统"></el-input>
                            </div>
                            <div class="resource-name">
                                <div>网络要求</div>
                                <el-input style="width: 100%;" type="textarea" v-model="form.networkAsk"
                                    placeholder="请输入网络要求"></el-input>
                            </div>
                        </div>

                        <upload-chunk v-else :accept="uploadAccept" ref="chunk" :multiple="false" @upload="upload"
                            @del_file="upload"></upload-chunk>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div class="input-box">
                <div @click="handleClick">搜索</div>
                <el-input v-model="keywords" style="width: 20rem;margin-left: 1rem;" @keydown.enter.native="handleClick"
                    clearable @clear="handleClick" placeholder="请输入内容"></el-input>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" v-debounce="save">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import UploadChunk from '../../common/UploadChunk.vue';
import { uploadFile } from '@/assets/js/oss';
import { PageResourceList, AddResource, GetDataTypeResDataCount } from '@/api/resourceMag';
import { SoftwarePageList, AddSoftware } from '@/api/software';
import { Category } from '@/utils/utils';
import { UpdateTeachingUnit } from '@/api/teachUnit';
import NoData from '../../common/NoData.vue';
export default {
    components: { UploadChunk, NoData },
    data() {
        return {
            Category,
            /**资源数量 */
            resNum: {
                '0': 0,
                '1': 0,
                '2': 0
            },
            dialogVisible: false,
            classifyCode: '',
            /**当前主体资源 */
            currentRaw: {},
            resourceName: '',
            keywords: '',
            pages: {
                current: 1,
                size: 12,
                total: 0,
                totalPages: 0,
            },
            /**手动上传资源封面图 */
            cover: {
                coverFileId: '',
                coverPath: ''
            },
            /**上传的文件 */
            file: {},
            /**资源简介 */
            info: '',
            /**资源链接 */
            url: '',
            form:{
                resType:'网页',
                drillTarget:"",
                drillTheory:"",
                drillStep:"",
                drillMethodCourse:"",
                drillConclusion:'',
                hardwareAsk:'',
                os:'',
                networkAsk:''
            },
            tableData: [],
            currentTab: 'myself',
        }
    },
    computed: {
        uploadAccept() {
            var obj = {
                '仿真软件': '.exe',
                '模型': '.fbx,.obj',
                '视频': '.mp4,.avi,.ts,.flv,.avi,.wmv',
                '图片': '.png,.jpg,.jpeg',
                '文档': ".doc,.docx,.pdf,.xls,.xlsx",
                'ppt': '.ppt,.pptx'
            }
            return obj[this.currentRaw.mainType];
        },
    },
    methods: {
        init() {
            this.pages = {
                current: 1,
                size: 12,
                total: 0,
                totalPages: 0,
            };
            /**手动上传资源封面图 */
            this.cover = {
                coverFileId: '',
                coverPath: ''
            };
            this.form={
                resType:'网页',
                drillTarget:"",
                drillTheory:"",
                drillStep:"",
                drillMethodCourse:"",
                drillConclusion:'',
                hardwareAsk:'',
                os:'',
                networkAsk:''
            };
            /**上传的文件 */
            this.file = {};
            /**上传的资源名称 */
            this.resourceName = '';
            /**资源简介 */
            this.info = '';
            /**资源链接 */
            this.url = '';
            /**所属分类 */
            this.classifyCode = this.$store.state.course.classifyCode;
            this.currentTab = 'myself';
            this.initChunk([]);
        },
        changeCategory() {
            this.pages.current = 1;
            this.handleClick();
            this.getDataTypeResDataCount();
        },
        /**获取数据类型资源数量 */
        getDataTypeResDataCount() {
            var params = {
                "classifyCode": this.classifyCode,
                "resTypeList": [this.currentRaw.mainType],
                "resType": '网页'
            };
            GetDataTypeResDataCount(params).then(res => {
                if (res.code == 200) {
                    var resNum = {
                        '0': 0,
                        '1': 0,
                        '2': 0
                    }
                    for (var key in resNum) {
                        var el = res.data.find(item => item.dataType == key);
                        if (el) {
                            resNum[key] = el.count;
                        }
                    }
                    this.resNum = resNum;
                }
            })
        },
        /**分页查询仿真软件 */
        softwarePageList(dataType) {
            var params = {
                "classifyCode": this.classifyCode,
                "current": this.pages.current,
                "dataType": dataType,
                "third": false,
                "resType": '网页',
                "resourceName": this.keywords,
                "resType": '网页',
                "size": this.pages.size
            };
            SoftwarePageList(params).then(res => {
                if (res.code == 200) {
                    this.pages.total = res.data.total;
                    this.tableData = res.data.records.map(item => {
                        return {
                            coverPath: item.softwareCover,
                            id: item.id,
                            resourceName: item.softwareName
                        }
                    });
                    this.dialogVisible = true;
                }
            })
        },
        /**分页查询基础资源 */
        pageResourceList(dataType) {
            var params = {
                "classifyCode": this.classifyCode,
                "current": this.pages.current,
                "dataType": dataType,
                "resourceName": this.keywords,
                "size": this.pages.size,
                "type": this.currentRaw.mainType
            };
            PageResourceList(params).then(res => {
                if (res.code == 200) {
                    this.pages.total = res.data.total;
                    this.tableData = res.data.records;
                    this.dialogVisible = true;
                }
            })
        },
        /**更新教学单元 */
        updateTeachingUnit() {
            var obj = {
                myself: 2,
                college: 1,
                cloud: 0
            };
            this.currentRaw.dataType = obj[this.currentTab];
            UpdateTeachingUnit(this.currentRaw).then(res => {
                if (res.code == 200) {
                    this.$msg({
                        showClose: true,
                        message: "保存成功",
                        type: "success",
                    });
                    this.dialogVisible = false;
                    this.$emit('main_dialog');
                }
            })
        },
        changeCurrent(e) {
            this.pages.current = e;
            var obj = {
                myself: 2,
                college: 1,
                cloud: 0
            }
            if (this.currentRaw.mainType == '仿真软件') {
                this.softwarePageList(obj[this.currentTab]);
                return;
            };
            this.pageResourceList(obj[this.currentTab]);
        },
        /**初始化文件上传 */
        initChunk(data) {
            var dialog = this.$refs.chunk;
            if (dialog) {
                dialog.fileArr = data;
            }
        },
        /**新增仿真软件 */
        addSoftware() {
            var params = {
                "classify": this.classifyCode,
                "explainInfo": this.info,
                "orderIndex": '',
                "softwareCode": "",
                "softwareCover": this.cover.coverPath,
                "softwareName": this.resourceName,
                "resType":'网页',
                "url": this.url,
                "drillTarget":this.form.drillTarget,
                "drillTheory":this.form.drillTheory,
                "drillStep":this.form.drillStep,
                "drillMethodCourse":this.form.drillMethodCourse,
                "drillConclusion":this.form.drillConclusion,
                "hardwareAsk":this.form.hardwareAsk,
                "os":this.form.os,
                "networkAsk":this.form.networkAsk
            }
            AddSoftware(params).then(res => {
                if (res.code == 200) {
                    this.currentRaw.resourceId = res.data;
                    this.updateTeachingUnit();
                    this.getDataTypeResDataCount();
                }
            })
        },
        /**上传封面图 */
        uploadCover(e) {
            uploadFile(e.raw).then(res => {
                this.cover.coverFileId = res.id;
                this.cover.coverPath = res.previewUrl;
            })
        },
        /**保存 */
        save() {
            if (['cloud', 'college', 'myself'].includes(this.currentTab)) {
                if (!this.currentRaw.resourceId) {
                    this.$msg({
                        showClose: true,
                        message: "请先选择资源再保存",
                        type: "warning",
                    });
                    return;
                }
                this.updateTeachingUnit();
            } else {
                if (this.currentRaw.mainType == '仿真软件') {
                    this.addSoftware();
                    return;
                }
                this.addResource();
            }
        },
        /**本地新增资源 */
        addResource() {
            var params = {
                "classifyCode": this.classifyCode,
                "coverFileId": this.cover.coverFileId,
                "coverPath": this.cover.coverPath,
                "fileIds": [this.file.id],
                "fileName": this.file.fileName,
                "info": this.info,
                "resUrl": this.url,
                "resourceCode": "",
                "resourceName": this.resourceName,
                "type": this.currentRaw.mainType
            }
            if (this.currentRaw.mainType == '仿真软件') {
                delete params.fileIds;
                delete params.fileName;
            } else {
                delete params.resUrl;
            }
            AddResource(params).then(res => {
                if (res.code == 200) {
                    this.currentRaw.resourceId = res.data;
                    this.updateTeachingUnit();
                    this.getDataTypeResDataCount();
                }
            })
        },
        handleClick() {
            var obj = {
                myself: 2,
                college: 1,
                cloud: 0
            }
            if (obj[this.currentTab] === undefined) return;
            this.pages.current = 1;
            if (this.currentRaw.mainType == '仿真软件') {
                this.softwarePageList(obj[this.currentTab]);
                return;
            };
            this.pageResourceList(obj[this.currentTab]);
        },
        /**选择资源 */
        selectItem(item) {
            this.currentRaw.resourceId = item.id;
        },
        /**本地上传 */
        upload(file) {
            this.file = file[0];
            if (!this.resourceName) {
                this.resourceName = file[0].fileName;
            }
        }
    }
}
</script>

<style lang="less" scoped>
.res-img{
    width: 100%;
    height: 100%;
    cursor: pointer;
    transition: all 0.3s;
}
/deep/.el-dialog__title {
    color: #334681;
    font-weight: 700;
    font-size: 16px;
}

/deep/.el-dialog {
    border-radius: 10px;
}

.dialog-footer {
    text-align: center;
}

.top-banner {
    display: flex;
    align-items: center;
    font-size: 14px;

    &> :nth-child(1) {
        color: #8590B3;
    }

    &> :nth-child(2) {
        color: #000000;
    }

    &> :nth-child(3) {
        background-color: rgba(56, 125, 255, 0.2);
        color: var(--blue);
        padding: 1px 3px;
        margin-left: 5px;
    }
}

.radio-box {
    padding: 3rem 0;
    border-bottom: 1px solid #EAEBF0;
    display: flex;
    align-items: center;
    color: #8590B3;

    &> :nth-child(1) {
        margin-top: -4px;
    }
}

.table-box {
    height: 50rem;
    border: 1px solid #e8ecef;
    padding: 0 2rem;
    position: relative;
    padding-bottom: 2rem;
}

/deep/.el-tabs__item {
    height: 6rem;
    line-height: 6rem;
}

.input-box {
    display: flex;
    align-items: center;
    color: #334681;
    position: absolute;
    right: 2.2rem;
    top: 1.3rem;
}

/deep/.el-tabs {
    height: 100%;
}

/deep/.el-tabs__content {
    height: calc(100% - 6rem) !important;
}

/deep/.el-tab-pane {
    height: 100%;
}

.upload-box,
.software-box {
    height: 100%;
    overflow: auto;
}

.box {
    height: calc(100% - 8rem);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    &> :nth-child(n) {
        margin-left: 2rem;
    }

    &> :nth-child(6n+1) {
        margin-left: 0;
    }

    &> :nth-child(n+7) {
        margin-top: 2rem;
    }

    .table-item {
        width: calc((100% - 10rem)/6);
        cursor: pointer;

        .cover-img {
            width: 100%;
            aspect-ratio: var(--aspectRatio);
            border-radius: 4px;
        }

        .cover-name {
            color: #334681;
            font-size: 14px;
            margin-top: 1rem;
        }
    }
}

.active {
    color: var(--blue) !important;
    font-weight: 700;
}

.resource-name {
    display: flex;
    align-items: center;
    margin-bottom: 2rem;

    &> :nth-child(1) {
        margin-right: 1rem;
    }
}

.form-item {
    display: flex;
    width: calc(100% - 10px);

    &> :nth-child(n) {
        flex: 1;
    }

    &> :nth-child(2) {
        margin-left: 2rem;
    }
}

.img-cover {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 14.4rem;
    height: 14.4rem;
    border-radius: 5px;
}

.page-box {
    text-align: center;
    width: 100%;
    padding: 2rem 0;
}

.cover-box {
    margin-bottom: 3rem;
    display: flex;
    align-items: center;

    &> :nth-child(1) {
        margin-right: 1rem;
    }

    /deep/.el-upload {
        width: 50px;
        height: 50px;
        position: relative;
    }

    /deep/.el-icon-plus {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>